import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string | null;
  description: string;
  path: string;
  type?: string;
  image?: string;
  jsonLd?: Record<string, unknown>;
}

const BASE_URL = "https://fshn.institute";
const DEFAULT_IMAGE = `${BASE_URL}/assets/og-image-default.webp`;

export const SEOHead = ({
  title,
  description,
  path,
  type = "website",
  image,
  jsonLd,
}: SEOHeadProps) => {
  const fullUrl = `${BASE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;
  const fullTitle = title
    ? `${title} | FSHN Institute`
    : "FSHN Institute — AI Fashion Prompt Engineering";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="FSHN Institute" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};
